<template>
  <b-modal 
      id="welcome-popup" 
      ref="welcome-popup" 
      size="lg"
      centered
      hide-footer
      hide-header
      hide-body
      @hide="storePermissionToUseData(); focusInputArea()"
      title="">
        <div class="row welcome-popup-content">
            <a class="welcome-close-link" href="#" @click="hideModal"><i class="fa fa-times"></i></a>
            <div class="col-4 welcome-right-side">
                <div class="welcome-inner-content">
                    <h1 class="text-white">ברוכים הבאים</h1>
                    <p class="text-white">כמה טיפים לפני שמתחילים</p>
                </div>
            </div>
            <div class="col-8 welcome-left-side">
                <div class="welcome-inner-content">
                    <p>נקדו באופן ידני עם מקלדת המחשב (בלי Alt או Capslock) <br />אחרי שתלחצו על הכפתור ״החל ניקוד״, תוכלו להגדיר את שיטת הניקוד בכפתור ״מקלדת ניקוד״ שיופיע משמאל לתיבת הטקסט</p>
                    <hr />
                    <div class="row align-content-center py-2">
                        <div class="col-4 align-self-center">
                            <p class="mb-0">מעבר בין מילים</p>
                        </div>
                        <div class="col-8">
                                <div class="d-inline-flex align-items-center">
                                    <button type="button" class="btn btn-link keyboard-btn">
                                        <i class="fa fa-caret-right fa-lg"></i>
                                    </button>
                                    <button type="button" class="btn btn-link keyboard-btn">
                                        <i class="fa fa-caret-left fa-lg"></i>
                                    </button>
                                </div>

                        </div>

                    </div>
                    <div class="row align-content-center py-2">
                        <div class="col-4 align-self-center">
                            <p class="mb-0">מעבר בין <br>אפשרויות ניקוד</p>
                        </div>
                        <div class="col-8 align-self-center">
                            <div class="d-inline-flex align-items-center">
                                <button type="button" class="btn btn-link keyboard-btn">
                                    <i class="fa fa-caret-down fa-lg"></i>
                                </button>
                                <button type="button" class="btn btn-link keyboard-btn">
                                    <i class="fa fa-caret-up fa-lg"></i>
                                </button>
                            </div>

                        </div>

                    </div>
                    <div class="row align-content-center py-2">
                        <div class="col-4 align-self-center">
                            <p class="mb-0">מעבר בין אותיות</p>
                        </div>
                        <div class="col-8">
                            <div class="d-flex">
                                <div class="d-inline-flex align-items-center">
                                    <button type="button" class="btn btn-link keyboard-btn">B</button>
                                    <button type="button" class="btn btn-link keyboard-btn">N</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row align-content-center py-2">
                        <div class="col-4 align-self-center">
                            <p class="mb-0">מחיקת אות / ניקוד</p>
                        </div>
                        <div class="col-8">
                            <div class="d-flex">
                                <div class="d-inline-flex align-items-center">
                                    <button type="button" class="btn btn-link keyboard-btn">Backspace</button>
                                </div>
                                <span class="key-divider"></span>
                                <div class="d-inline-flex align-items-center">
                                    <button type="button" class="btn btn-link keyboard-btn">
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row align-content-center py-2">
                        <div class="col-4 align-self-center">
                            <p class="mb-0">עריכת טקסט</p>
                        </div>
                        <div class="col-8">
                            <div class="d-flex">
                                <div class="d-inline-flex align-items-center">
                                    <button type="button" class="btn btn-link keyboard-btn">E</button>
                                    <span class="mx-1">+</span>
                                    <button type="button" class="btn btn-link keyboard-btn">Shift</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="mb-2" />
                    <div class="mb-2">
                        <b-form-checkbox v-model="permissionToUseData">
                            עיזרו לנו לשפר את הנקדן עם שימוש אנונימי בנתונים שלכם
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
            <a class="welcome-bottom-link" href="#" @click="showKeyboardShortcutsClicked">קיצורי מקלדת</a>
        </div>
  </b-modal>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'Welcome',
  data () {
      return {
          permissionToUseData: true,
      }
  },
  methods: {
    storePermissionToUseData () {
      window.localStorage.setItem('permission-to-use-pro-nakdan-data', JSON.stringify(this.permissionToUseData))
    },
    focusInputArea () {
      setTimeout(() => {
        $('.main-input-box').focus()        
      }, 1)
    },
    hideModal () {
      this.$refs['welcome-popup'].hide()
    },
    showKeyboardShortcutsClicked () {
      this.hideModal()
      this.$emit('show-keyboard-shortcuts')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .welcome-popup-content {
        min-height: 450px;
        margin: -16px;
        position: relative;
        border-radius: 4px;
    }

    .welcome-right-side {
        background-image: linear-gradient(#055EA6, #007EE5);

    }
    .welcome-close-link{
        position: absolute;
        right: 15px;
        top: 10px;
        color: #fff;
        z-index: 1;
    }
    .welcome-bottom-link{
        position: absolute;
        right: 15px;
        bottom: 15px;
        text-decoration: underline;
        color: #fff;
    }
    .welcome-inner-content {
        padding-top: 70px;
    }

    .keyboard-btn {
        border: 1px solid #D1D0D0;
        border-radius: 3px;
        padding: 4px 8px;
        min-width: 30px;
        height: 28px;
        font-size: 16px;
        line-height: 2px;
        background: #fff;
        box-shadow: 0 1px 0 0 rgba(0, 0, 0, .17);
        margin-left: 1px;
        cursor: text !important;
    }
    .keyboard-btn:focus, .keyboard-btn:active
    {
        box-shadow: 0 1px 0 0 rgba(0, 0, 0, .17) !important;
    }
    .key-divider {
        width: 1px;
        background: #E3E3E3;
        margin: 4px;
        height: 20px;
        vertical-align: middle;
    }
</style>
